import {
  GET_LABREQUESTTESTSAMPLE,
  GET_LABREQUESTTESTSAMPLE_FAIL,
  GET_LABREQUESTTESTSAMPLE_SUCCESS,
  GET_LABREQUESTTESTSAMPLES,
  GET_LABREQUESTTESTSAMPLES_FAIL,
  GET_LABREQUESTTESTSAMPLES_SUCCESS,
  ADD_NEW_LABREQUESTTESTSAMPLE,
  ADD_LABREQUESTTESTSAMPLE_SUCCESS,
  ADD_LABREQUESTTESTSAMPLE_FAIL,
  UPDATE_LABREQUESTTESTSAMPLE,
  UPDATE_LABREQUESTTESTSAMPLE_SUCCESS,
  UPDATE_LABREQUESTTESTSAMPLE_FAIL,
  DELETE_LABREQUESTTESTSAMPLE,
  DELETE_LABREQUESTTESTSAMPLE_SUCCESS,
  DELETE_LABREQUESTTESTSAMPLE_FAIL,
  SET_STATE_LABREQUESTTESTSAMPLE
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTTESTSAMPLE,
  payload: loading,
})

export const getLabRequestTestSamples = ( params ) => ({
  type: GET_LABREQUESTTESTSAMPLES,
  payload: { params },
})

export const getLabRequestTestSamplesSuccess = (labRequestTestSamples, totalPages, currentPage) => ({
  type: GET_LABREQUESTTESTSAMPLES_SUCCESS,
  payload: { labRequestTestSamples:labRequestTestSamples, total:totalPages, currentPage:currentPage}
})

export const getLabRequestTestSamplesFail = error => ({
  type: GET_LABREQUESTTESTSAMPLES_FAIL,
  payload: error,
})

export const addNewLabRequestTestSample = labRequestTestSample => ({
  type: ADD_NEW_LABREQUESTTESTSAMPLE,
  payload: labRequestTestSample,
})

export const addLabRequestTestSampleSuccess = labRequestTestSample => ({
  type: ADD_LABREQUESTTESTSAMPLE_SUCCESS,
  payload: labRequestTestSample,
})  

export const addLabRequestTestSampleFail = error => ({
  type: ADD_LABREQUESTTESTSAMPLE_FAIL,
  payload: error,
})

export const updateLabRequestTestSample = labRequestTestSample => ({
  type: UPDATE_LABREQUESTTESTSAMPLE,
  payload: labRequestTestSample,
})

export const updateLabRequestTestSampleSuccess = labRequestTestSample => ({
  type: UPDATE_LABREQUESTTESTSAMPLE_SUCCESS,
  payload: labRequestTestSample,
})

export const updateLabRequestTestSampleFail = error => ({
  type: UPDATE_LABREQUESTTESTSAMPLE_FAIL,
  payload: error,
})

export const deleteLabRequestTestSample = labRequestTestSample => ({
  type: DELETE_LABREQUESTTESTSAMPLE,
  payload: labRequestTestSample,
})

export const deleteLabRequestTestSampleSuccess = id => ({
  type: DELETE_LABREQUESTTESTSAMPLE_SUCCESS,
  id,
})

export const deleteLabRequestTestSampleFail = error => ({
  type: DELETE_LABREQUESTTESTSAMPLE_FAIL,
  payload: error,
})

export const getLabRequestTestSample = () => ({
  type: GET_LABREQUESTTESTSAMPLE,
})

export const getLabRequestTestSampleSuccess = labRequestTestSample => ({
  type: GET_LABREQUESTTESTSAMPLE_SUCCESS,
  payload: labRequestTestSample,
})

export const getLabRequestTestSampleFail = error => ({
  type: GET_LABREQUESTTESTSAMPLE_FAIL,
  payload: error,
})
